import { useDirection, useSiteContext, useSnowplowTracking, useTranslation } from '@eti/providers';
import { css, cx } from '@eti/styles';
import { Illustration } from '@eti/components';
import { Link } from 'react-router-dom';
import Banner from '../../../../common/components/Banner';
import { routes } from '../../../../constants/routesAndApisConstants';
import { linkStyles } from '../../../../utils/styleUtils';

const illustrationStyles = css`
  align-self: center;
  height: auto;
  margin: 16px;
`;

const marginStyles = css`
  margin-top: auto;
`;

const AppBanner = () => {
  const { t } = useTranslation();
  const { brand } = useSiteContext();
  const { isRTL } = useDirection();
  const { isSnowplowTrackingEnabled, sendTrackEvent } = useSnowplowTracking();

  const handleSnowplowOnAppBanner = () => {
    if (isSnowplowTrackingEnabled) {
      sendTrackEvent({
        category: 'Overview',
        action: 'Click',
        label: 'DOWNLOAD_APP',
      });
    }
  };

  return (
    <Banner
      data-testid="order-details-app"
      description={t('OrderDetails.Banner.App.Description')}
      footer={
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <Link
          aria-label={`${t('OrderDetails.Banner.App.Link.Text')}, ${t(
            'ScreenReader.Link.OpensInNewTab.AriaLabel.Text',
          )}`}
          className={cx(linkStyles, marginStyles)}
          data-testid="order-details-app-link"
          onClick={() => {
            handleSnowplowOnAppBanner();
          }}
          rel="noreferrer"
          target="_blank"
          to={routes.MOBILE_APP_DOWNLOAD}
        >
          {t('OrderDetails.Banner.App.Link.Text')}
        </Link>
      }
      icon={
        <Illustration
          brand={brand.code}
          className={illustrationStyles}
          data-testid="order-details-app-icon"
          id="app"
          mirrored={isRTL}
          width={52}
        />
      }
      title={t('OrderDetails.Banner.App.Title')}
    />
  );
};

export default AppBanner;
